import React from 'react';
import Logo from "../assets/icons/CampusLLMLogoSmall.png";

const LoadingPage = () => (
  <div className="w-full h-full flex items-center justify-center">
      <div className="w-20 h-20 cursor-pointer bg-[#ffffff]/05 border border-[#ffffff]/15 backdrop-blur-lg p-0.5 rounded-md flex items-center justify-center">
          <img src={Logo} className="object-contain h-full w-full" alt="CampusLM Logo"/>
      </div>
  </div>
);

export default LoadingPage;